import { render, staticRenderFns } from "./VekaletAvukatForm.vue?vue&type=template&id=5337ad36&scoped=true"
import script from "./VekaletAvukatForm.vue?vue&type=script&lang=ts"
export * from "./VekaletAvukatForm.vue?vue&type=script&lang=ts"
import style0 from "./VekaletAvukatForm.vue?vue&type=style&index=0&id=5337ad36&prod&scoped=true&lang=css"
import style1 from "./VekaletAvukatForm.vue?vue&type=style&index=1&id=5337ad36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5337ad36",
  null
  
)

export default component.exports